import YoutubeVideo from "components/YoutubeVideo";
import { IPARQUE_SENSING } from "configs/links";
import { IntersectionObserverOptions } from "hooks/useIntersectionObserver";
import useOnScreen from "hooks/useOnScreen";
import { Text } from "iparque-components";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { sensingVideoIframeId, videoIds } from "./configs";
import {
  Container,
  Square,
  ContentContainer,
  StyledFullPageContainer,
  StyledHeading,
  TextContainer,
  VideoContainer,
} from "./styles";

interface Props {
  visible: boolean;
  scrollIntoView: () => void;
}

const intersectionOptions: IntersectionObserverOptions = {
  threshold: 0.1,
  unobserveOnIntersection: true,
};

const IParqueSensing: React.FC<Props> = ({ visible, scrollIntoView }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const childrenRef = useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(childrenRef, intersectionOptions);

  useEffect(() => {
    if (!visible || !containerRef.current || !childrenRef.current) {
      return;
    }

    containerRef.current.style.maxHeight = `${childrenRef.current.clientHeight}px`;

    setTimeout(() => {
      scrollIntoView();

      if (containerRef.current) {
        containerRef.current.style.maxHeight = "none";
      }
    }, 300);
  }, [scrollIntoView, visible]);

  return (
    <Container ref={containerRef}>
      <div id={IPARQUE_SENSING} ref={childrenRef}>
        <StyledFullPageContainer>
          <Square>
            <ContentContainer>
              <TextContainer isOnScreen={isOnScreen}>
                <StyledHeading elementType="h2" color="secondary">
                  iParque Sensing
                </StyledHeading>
                <Text color="secondary">
                  {
                    t(
                      "10140"
                    ) /* A solução ideal para a sua cidade. Encontre facilmente o seu estacionamento à distância! */
                  }
                </Text>
                <Text color="secondary" variant="body4" className="mt-20">
                  {
                    t(
                      "10141"
                    ) /* Estacionar em grandes centros urbanos pode ser desafiante. O iParque é a solução ideal para a sua cidade! */
                  }
                </Text>
                <Text color="secondary" variant="body4" className="mt-20">
                  {
                    t(
                      "10142"
                    ) /* Através da integração com os sistemas de sensores, o iParqueSensing possibilita ao condutor e às concessionárias identificar, com precisão e antecipação, os lugares de estacionamento que se encontram livres ou ocupados. */
                  }
                </Text>
              </TextContainer>
              <VideoContainer
                isOnScreen={isOnScreen}
                title={
                  t(
                    "9160"
                  ) /* Gestão de disponibilidade de lugares em tempo real. */
                }
              >
                <YoutubeVideo
                  id={sensingVideoIframeId}
                  videoIds={videoIds}
                  autoPlay={false}
                />
              </VideoContainer>
            </ContentContainer>
          </Square>
        </StyledFullPageContainer>
      </div>
    </Container>
  );
};

export default IParqueSensing;
